import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';

import { update_phone_mts_data, update_phone_a1_data, update_work_data } from '../../actions/update_data';

import Callback from './MobileCallback';

// import tg from './media/telegram.svg';
// import wup from './media/whatsapp.svg';
// import viber from './media/viber.svg';
import insta from './media/instagram.svg';
import fb from './media/facebook.svg';
import vk from './media/vkontakte.svg';
import logo_desk from './media/logo-desk.svg';
import logo_mob from './media/logo-mob.svg';
import mts from './media/mts.svg';
import a1 from './media/a1.svg';

//mob
import menuClose from './media/menuClose.svg';
import menuOpen from './media/menu.svg';
import phone from './media/phone.svg';

import './style.css';

let temp_pos = 0;

function scrollBy(distance, duration) {
    let initialY = temp_pos;
    let y = initialY + distance;
    let baseY = (initialY + y) * 0.5;
    let difference = initialY - baseY;
    let startTime = performance.now();
    function step() {
        let normalizedTime = (performance.now() - startTime) / duration;
        if (normalizedTime > 1) normalizedTime = 1;
        window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
        if (normalizedTime < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
}

export class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            header_is_visible: true,
            mob_menu_open: false,
            mob_modal_open: false
        }

        this._toggle_menu = this._toggle_menu.bind(this);
        this._toggle_modal = this._toggle_modal.bind(this);
        this._toggle_header = this._toggle_header.bind(this);
        this._scroll_to_mc = this._scroll_to_mc.bind(this);
        this._scroll_to_shedule = this._scroll_to_shedule.bind(this);
    }

    componentDidMount() {
        //функция обработки появления/исчезновения шапки
        let new_pos = 0;
        const toggle_header = this._toggle_header;
        window.addEventListener('scroll', () => {
            temp_pos = window.pageYOffset;
            if (temp_pos < 70) {
                toggle_header(true);
            } else if (temp_pos < new_pos) {
                if (new_pos - temp_pos > 100) {
                    toggle_header(true);
                    new_pos = temp_pos + 50;
                }
            } else {
                if (temp_pos > 1) {
                    new_pos = temp_pos;
                    toggle_header(false);
                }
            }
        });

        //функция вызова статических данных телефонов
        if (this.props.update_phone_mts_data.phone === undefined || this.props.updated_phone_a1_data.phone === undefined) {
            fetch(this.props.url+'wp-json/wp/v2/static-info/900').then((response) => {
                if(!response.ok) {
                    console.log("Что-то не так со статическими данными: " + response.statusText);
                }
                else return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data !== undefined && data !== null) {
                    let text = data.content.rendered;
    
                    //разбивка текста для получения значения
                    let phone_mts = text.split('class="phone-mts">')[1];
                    phone_mts = phone_mts.split('</p>')[0];
                    let phone_call_mts = phone_mts.replace(' ', '');
                    phone_call_mts = phone_call_mts.replace('-', '');
    
                    //рекурсивная функция для замены символов, чтобы можно было вставить в места где надо по клику делать звонок
                    let mts_checker = () => {
                        if (phone_call_mts.includes(' ')) {
                            phone_call_mts = phone_call_mts.replace(' ', '');
                            mts_checker();
                        } else if (phone_call_mts.includes('-')) {
                            phone_call_mts = phone_call_mts.replace('-', '');
                            mts_checker();
                        }
                    }
                    mts_checker();
                    
                    //сборка объекта
                    let mts = Object.create(null);
                    mts.phone = phone_mts;
                    mts.call = phone_call_mts;
    
                    //разбивка текста для получения значения
                    let phone_a1 = text.split('class="phone-a1">')[1];
                    phone_a1 = phone_a1.split('</p>')[0];
                    let phone_call_a1 = phone_a1.replace(' ', '');
                    phone_call_a1 = phone_call_a1.replace('-', '');
    
                    //рекурсивная функция для замены символов, чтобы можно было вставить в места где надо по клику делать звонок
                    let a1_checker = () => {
                        if (phone_call_a1.includes(' ')) {
                            phone_call_a1 = phone_call_a1.replace(' ', '');
                            a1_checker();
                        } else if (phone_call_a1.includes('-')) {
                            phone_call_a1 = phone_call_a1.replace('-', '');
                            a1_checker();
                        }
                    }
                    a1_checker();
                    
                    //сборка объекта
                    let a1 = Object.create(null);
                    a1.phone = phone_a1;
                    a1.call = phone_call_a1;
                    
                    //отправляем данные в store
                    this.props.update_phone_mts_data(mts);
                    this.props.update_phone_a1_data(a1);
                }
            })
        }

        //функция вызова статических данных состояния с данными о работе магазина сегодня
        if (this.props.updated_work_data === '') {
            fetch(this.props.url+'wp-json/wp/v2/static-info/899').then((response) => {
                if(!response.ok) {
                    console.log("Что-то не так со статическими данными: " + response.statusText);
                }
                else return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data !== undefined && data !== null) {
                    let text = data.content.rendered;
                    let month_arr = [], work_info = '';
                    //разбиваем текстовую переменную
                    month_arr = text.split('<p>');
                    month_arr.shift();
    
                    //проходим по массиву данных
                    for (let i = 0; i < month_arr.length; i++) {
                        let temp_month_data_arr = month_arr[i].split('</p>')[0];
                        let month_data_arr = temp_month_data_arr.split('<br>');
                        //проверка на пустые строки (чтобы пустые блоки не учитывались для избежания ошибок)
                        if (month_data_arr.length > 1) {
                            let month_name = month_data_arr[0];
                            //заменяем название месяца на цифру
                            switch (month_name) {
                                case 'Январь':
                                    month_name = 1;
                                    break;
                                case 'Февраль':
                                    month_name = 2;
                                    break;
                                case 'Март':
                                    month_name = 3;
                                    break;
                                case 'Апрель':
                                    month_name = 4;
                                    break;
                                case 'Май':
                                    month_name = 5;
                                    break;
                                case 'Июнь':
                                    month_name = 6;
                                    break;
                                case 'Июль':
                                    month_name = 7;
                                    break;
                                case 'Август':
                                    month_name = 8;
                                    break;
                                case 'Сентябрь':
                                    month_name = 9;
                                    break;
                                case 'Октябрь':
                                    month_name = 10;
                                    break;
                                case 'Ноябрь':
                                    month_name = 11;
                                    break;
                                case 'Декабрь':
                                    month_name = 12;
                                    break;
                                default:
                                    break;
                            }
    
                            //берём данные сегодняшнего дня для проверки
                            let date = new Date();
                            let today_month = date.getMonth()+1;
                            let today_day = date.getDate();
    
                            //проверяем на совпадение месяца
                            if (+month_name === +today_month) {
                                month_data_arr.shift();
                                //проходим по массиву данных месяца, чтобы найти нужную запись
                                for (let l = 0; l < month_data_arr.length; l++) {
                                    let temp_data = month_data_arr[l].split(' &#8212; '); //здесь указан код символа `-`
                                    let day_data = temp_data[0];
                                    if (+today_day === +day_data) {
                                        work_info = temp_data[1];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    this.props.update_work_data(work_info);
                }
            })
        }
    }

    componentDidUpdate() {
        if (this.state.mob_menu_open === true || this.state.mob_modal_open === true) {
            let body = document.getElementsByTagName('body')[0];
            body.style.overflowY = 'hidden';
        } else {
            let body = document.getElementsByTagName('body')[0];
            body.style.overflowY = '';
        }
        if (this.state.mob_modal_open && this.state.mob_menu_open) {
            this.setState({
                mob_menu_open: false
            })
        }
    }

    _toggle_menu() {
        this.setState({
            mob_menu_open: !this.state.mob_menu_open
        })
    }

    _toggle_modal() {
        this.setState({
            mob_modal_open: !this.state.mob_modal_open
        })
    }

    _toggle_header(bool) {
        this.setState({
            header_is_visible: bool
        })
    }

    _scroll_to_mc() {
        if(window.location.pathname !== '/') {
            setTimeout(() => {
                let to_mc_dist = document.getElementById('mc-dist');
                if(to_mc_dist != null) {
                    scrollBy(to_mc_dist.offsetTop-70-temp_pos, 500);
                }
            }, 100);
        } else {
            temp_pos = window.pageYOffset;
            let to_mc_dist = document.getElementById('mc-dist');
            if(to_mc_dist != null) {
                scrollBy(to_mc_dist.offsetTop-70-temp_pos, 500);
            }
        }
        if (this.state.mob_menu_open === true) {
            this.setState({
                mob_menu_open: !this.state.mob_menu_open
            })
        }
    }

    _scroll_to_shedule() {
        if(window.location.pathname !== '/') {
            setTimeout(() => {
                let to_shedule_dist = document.getElementById('shedule-dist');
                if(to_shedule_dist != null) {
                    scrollBy(to_shedule_dist.offsetTop-70-temp_pos, 500);
                }
            }, 1500);
        } else {
            temp_pos = window.pageYOffset;
            let to_shedule_dist = document.getElementById('shedule-dist');
            if(to_shedule_dist != null) {
                scrollBy(to_shedule_dist.offsetTop-70-temp_pos, 500);
            }
        }
    }

    render() {
        //desktop сектор
        let modal = 'header-container';
        if(this.props.modalIsOpen) {
            modal += ' modal-open';
        }

        //mobile сектор
        let menu = menuOpen;
        let header_menu = 'header__menu';
        let mobile_container = 'mobile-container';
        let master_class_navbar = 'mc-navigation';
        if (this.state.mob_menu_open === true) {
            header_menu += ' menu-open';
            mobile_container += ' header-lock';
            menu = menuClose;
        }
        if (this.state.header_is_visible === false) {
            mobile_container += ' header-invisible';
            modal += ' header-container_hide';
            master_class_navbar += ' mc-navigation_full';
        }
        let headerClass = 'd-c-none';
        if (this.state.mob_modal_open === true) {
            headerClass += ' modal-open';
        }

        //common сектор
        if(this.props.navigation_menu_show === true) {
            master_class_navbar += ' mc-navigation_open';
        }

        return (
            <div className={modal}>
                {/* desktop */}
                <header className='header-small d-m-none'>
                    <div className="header__logo">
                        <Link to="/" itemProp="url">
                            <img src={logo_desk} className="logo d-m-none" alt="logo" itemProp="image" />
                        </Link>
                    </div>
                    <nav className="header__menu">
                        <div className="menu_item">
                            <Link to="/mc">
                                Мастер-классы
                            </Link>
                        </div>
                        <div className="menu_item">
                            <Link to="/" id="shedule" onClick={this._scroll_to_shedule}>
                                Расписание
                            </Link>
                        </div>
                        <div className="menu_item">
                            <Link to="/certificates">
                                Сертификаты
                            </Link>
                        </div>
                        <div className="menu_item">
                            <Link to="/contacts">
                                Контакты
                            </Link>
                        </div>
                        <div className="menu_item">
                            <Link to='/business'>
                                Бизнесу
                            </Link>
                        </div>
                    </nav>
                    <div className="header__contact">
                        <div className="fl-b__column header__contact-container">
                            <p className="header__contact-phone"><img src={mts} className="header__contact-icon" alt="icon" />{this.props.updated_phone_mts_data.phone}</p>
                            <p className="header__contact-phone"><img src={a1} className="header__contact-icon" alt="icon" />{this.props.updated_phone_a1_data.phone}</p>
                        </div>
                        <div className="work-info">
                            <Link to="/contacts" className="work-info__text">
                                ул. Чернышевского, 10<br/>
                                {this.props.updated_work_data}
                            </Link>
                            {/* <Link to="/contacts" className="work-info__text">
                                
                            </Link> */}
                        </div>
                        {/* <section className="header__contact_soc">
                            <Link to="">
                                <img src={tg} alt="telegram-logo" />
                            </Link>
                            <Link to="">
                                <img src={wup} alt="telegram-logo" />
                            </Link>
                            <Link to="">
                                <img src={viber} alt="telegram-logo" />
                            </Link>
                        </section> */}
                        <section className="header__contact_soc">
                            <a href="https://www.instagram.com/moonceramic/" target="_blank" rel="noopener noreferrer">
                                <img src={insta} alt="telegram-logo" />
                            </a>
                            <a href="https://www.facebook.com/moonceramicstudio/" target="_blank" rel="noopener noreferrer">
                                <img src={fb} alt="telegram-logo" />
                            </a>
                            <a href="https://vk.com/moonceramic" target="_blank" rel="noopener noreferrer">
                                <img src={vk} alt="telegram-logo" />
                            </a>
                        </section>
                    </div>
                </header>
                {/* mobile */}
                <header className={headerClass}>
                    <div className={mobile_container}>
                        <nav className={header_menu}>
                            <div className="menu_item">
                                <Link to="/mc">
                                    Мастер-классы
                                </Link>
                            </div>
                            <div className="menu_item" onClick={this._scroll_to_shedule}
                                onKeyDown={this._scroll_to_shedule} role="button"
                                tabIndex="0" id="shedule">
                                <Link to="/">
                                    Расписание
                                </Link>
                            </div>
                            <div className="menu_item" onClick={this._toggle_menu}
                                onKeyDown={this._toggle_menu} role="button"
                                tabIndex="0">
                                <Link to="/certificates">
                                    Сертификаты
                                </Link>
                            </div>
                            <div className="menu_item" onClick={this._toggle_menu}
                                onKeyDown={this._toggle_menu} role="button"
                                tabIndex="0">
                                <Link to="/contacts">
                                    Контакты
                                </Link>
                            </div>
                            <div className="menu_item" onClick={this._toggle_menu}
                                onKeyDown={this._toggle_menu} role="button"
                                tabIndex="0">
                                <Link to="/business">
                                    Бизнесу
                                </Link>
                            </div>
                            <div className="menu_social">
                                <a href="https://www.instagram.com/moonceramic/" target="_blank" rel="noopener noreferrer">
                                    <img src={insta} alt="telegram-logo" />
                                </a>
                                <a href="https://www.facebook.com/moonceramicstudio/" target="_blank" rel="noopener noreferrer">
                                    <img src={fb} alt="telegram-logo" />
                                </a>
                                <a href="https://vk.com/moonceramic" target="_blank" rel="noopener noreferrer">
                                    <img src={vk} alt="telegram-logo" />
                                </a>
                            </div>
                            <div className="menu-work-hours_container">
                                <Link to="/contacts" className="menu-work-hours">
                                    ул. Чернышевского, 10<br/>
                                    {this.props.updated_work_data}
                                </Link>
                            </div>
                        </nav>
                        <div className="mobile-header">
                            <div className="header__menu_ico" onClick={this._toggle_menu}
                                onKeyDown={this._toggle_menu} role="button"
                                tabIndex="0">
                                <button className="btn">
                                    <img src={menu} alt="menu" />
                                </button>
                            </div>
                            <div className="header__logo">
                                <Link to="/" itemProp="url">
                                    <img src={logo_mob} className="logo d-c-none" alt="logo" itemProp="image" />
                                </Link>
                            </div>
                            <div className="header__phone_ico" onClick={this._toggle_modal}
                                onKeyDown={this._toggle_modal} role="button"
                                tabIndex="0">
                                <button className="btn">
                                    <img src={phone} alt="phone" />
                                </button>
                            </div>
                        </div>
                        <select className={master_class_navbar+" d-m-none"} defaultValue="Описание" id="nav-menu">
                            <option className="mc-navigation_item" id="description_mob">Описание</option>
                            <option className="mc-navigation_item" id="pupil_work_mob">Работы учеников</option>
                            <option className="mc-navigation_item" id="reviews_mob">Реальные отзывы</option>
                            <option className="mc-navigation_item" id="map_mob">Как проехать?</option>
                    </select>
                    </div>
                    {
                        this.state.mob_modal_open ? <Callback click={this._toggle_modal} mts={this.props.updated_phone_mts_data} a1={this.props.updated_phone_a1_data} work_info={this.props.updated_work_data} /> : null
                    }
                    {/* <div className="header__contact">
                        <p>+375 33 123-86-54</p>
                    </div> */}
                </header>
                {this.props.navigation_menu_show ? <hr></hr> : null}
                <nav className={master_class_navbar + " d-m-none"}>
                    <div className="mc-navigation_item">
                        <button id="description">Описание</button>
                    </div>
                    <div className="mc-navigation_item">
                        <button id="pupil_work">Работы учеников</button>
                    </div>
                    <div className="mc-navigation_item">
                        <button id="reviews">Реальные отзывы</button>
                    </div>
                    <div className="mc-navigation_item">
                        <button id="map">Как проехать?</button>
                    </div>
                </nav>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    navigation_menu_show: state.navigation_menu_show,
    updated_phone_mts_data: state.updated_phone_mts_data,
    updated_phone_a1_data: state.updated_phone_a1_data,
    updated_work_data: state.updated_work_data,
    url: state.site_options.SITE_URL
})

const mapDispatchToProps = (dispatch) => ({
    update_phone_mts_data: (data) => dispatch(update_phone_mts_data(data)),
    update_phone_a1_data: (data) => dispatch(update_phone_a1_data(data)),
    update_work_data: (text) => dispatch(update_work_data(text))
})

export default connect(mapStateToProps, mapDispatchToProps)(Header);